import React, { FC } from 'react';
import { Button, Icon } from '@gumtree/ui-library';
import styled from '@emotion/styled';
import { trackV2 } from '@gumtree/shell/src/common/common-actions';

import { breakpoints, gutterSizes, mediaQuery } from '@gumtree/ui-library/src/base/theme';
import { useModal } from '@gumtree/shell/src/use-modal';
import { LoginModalType } from '@gumtree/shell/src/reducers/common/login-modal';

const StyledButton = styled(Button)`
    && {
        padding: 0 ${gutterSizes.base};
        max-width: 170px;

        ${mediaQuery.until(breakpoints.large)} {
            margin-top: ${gutterSizes.medium};
        }

        ${mediaQuery.from(breakpoints.large)} {
            grid-column: 2;
            justify-self: self-end;
        }
    }
`;

interface Props {
    sellOneUrl: string;
    isUserLoggedIn: boolean;
}

const SellOneLink: FC<Props> = ({ sellOneUrl, isUserLoggedIn }) => {
    const { openDialog } = useModal();

    return (
        <StyledButton
            {...(isUserLoggedIn && { href: sellOneUrl })}
            display="quarternary"
            icon={<Icon type="pin" />}
            label="Sell one like this"
            onClick={() => {
                if (isUserLoggedIn) return;
                openDialog(undefined, LoginModalType.LOGIN, true, sellOneUrl);
                trackV2('SellOneLikeThis', 'SellOneLikeThis');
            }}
        />
    );
};

export default SellOneLink;
